(function () {
  const MOBILE_BREAKPOINT = 750;

  class TrustSignalBanner {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.enableDesktop = root.dataset.popupDesktop === 'true';
      this.enableMobile = root.dataset.popupMobile === 'true';
      this.overlay = root.querySelector('.trust-signal__popup-overlay');
      this.popupData = root.querySelector('.trust-signal__popup-data');
      this.track = root.querySelector('.trust-signal__track');
      this.dialog = this.overlay?.querySelector('[role="dialog"]');
      this.popupTitle = root.querySelector('.trust-signal__popup-title');
      this.popupDescription = root.querySelector('.trust-signal__popup-description');
      this.popupButton = root.querySelector('.trust-signal__popup-button');
      this.closeBtn = this.overlay?.querySelector('.trust-signal__popup-close');
      // Only real <button> tiles are toggled disabled/focusable. Clone tiles
      // (duplicated marquee items) are non-focusable divs handled via delegation.
      this.buttons = root.querySelectorAll('button.trust-signal__tile--interactive');
      this.lastOpener = null;
      this.isOpen = false;

      this.onRootClick = this.onRootClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onOverlayClick = this.onOverlayClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onResize = this.onResize.bind(this);

      this.init();
    }

    init() {
      if (!this.overlay || !this.popupData) return;

      // Delegated click so both original and cloned (marquee) tiles work.
      this.root.addEventListener('click', this.onRootClick);

      this.closeBtn?.addEventListener('click', this.onCloseClick);
      this.overlay.addEventListener('click', this.onOverlayClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.onResize);

      this.updateTileInteractivity();
    }

    isMobile() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }

    shouldEnablePopup() {
      // Tablet and desktop (>= 750px) follow the desktop toggle; below follows mobile.
      return this.isMobile() ? this.enableMobile : this.enableDesktop;
    }

    updateTileInteractivity() {
      const enabled = this.shouldEnablePopup();
      this.buttons.forEach((button) => {
        button.disabled = !enabled;
        button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        button.tabIndex = enabled ? 0 : -1;
      });
    }

    onResize() {
      this.updateTileInteractivity();
    }

    onRootClick(event) {
      const tile = event.target.closest('.trust-signal__tile--interactive');
      if (!tile || !this.root.contains(tile)) return;
      if (!this.shouldEnablePopup()) return;
      event.preventDefault();
      this.openPopup(tile);
    }

    openPopup(tile) {
      const blockIndex = tile.getAttribute('data-block-index');
      const dataElement = this.popupData.querySelector('[data-block-index="' + blockIndex + '"]');

      if (!dataElement) return;

      const description = dataElement.textContent.trim();
      const title = dataElement.getAttribute('data-popup-title') || '';
      const buttonText = dataElement.getAttribute('data-popup-button-text') || '';
      const buttonUrl = dataElement.getAttribute('data-popup-button-url') || '';

      if (!description) return;

      this.lastOpener = tile;
      this.popupDescription.textContent = description;
      this.popupTitle.textContent = title;

      if (buttonUrl && buttonText) {
        this.popupButton.href = buttonUrl;
        this.popupButton.innerHTML =
          buttonText +
          '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="#666" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"/></svg>';
        this.popupButton.style.display = 'inline-flex';
      } else {
        this.popupButton.style.display = 'none';
      }

      this.overlay.classList.add('is-active');
      this.overlay.setAttribute('aria-hidden', 'false');
      this.track?.classList.add('is-paused');
      document.body.style.overflow = 'hidden';
      this.isOpen = true;

      if (typeof trapFocus === 'function' && this.dialog) {
        trapFocus(this.overlay, this.closeBtn || this.dialog);
      }
    }

    closePopup() {
      if (!this.isOpen) return;

      this.overlay.classList.remove('is-active');
      this.overlay.setAttribute('aria-hidden', 'true');
      this.track?.classList.remove('is-paused');
      document.body.style.overflow = '';
      this.isOpen = false;

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.lastOpener);
      }
    }

    onCloseClick(event) {
      event.stopPropagation();
      this.closePopup();
    }

    onOverlayClick(event) {
      if (event.target === this.overlay) {
        this.closePopup();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.closePopup();
      }
    }
  }

  function initTrustSignalBanners() {
    document.querySelectorAll('.trust-signal[data-section-id]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      new TrustSignalBanner(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustSignalBanners);
  } else {
    initTrustSignalBanners();
  }

  document.addEventListener('shopify:section:load', initTrustSignalBanners);
})();
